import SVG from './SVG'

export const CloseSVG = (props) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || 24}
      height={props.height || 24}
      viewBox="0 0 24 24"
      {...props}
    >
      <g className="btn_close_24">
        <path
          fillRule="evenodd"
          d="M18.707 6.707a1 1 0 00-1.414-1.414L12 10.586 6.707 5.293a1 1 0 00-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 101.414 1.414L12 13.414l5.293 5.293a1 1 0 001.414-1.414L13.414 12l5.293-5.293z"
          className="Union"
          clipRule="evenodd"
        />
      </g>
    </SVG>
  )
}
